module.exports = __webpack_public_path__ + "img/arly.ef9184ec.svg";